/**
 * Class to keep track of "mouse" position
 * TODO Switch to use a pointevent polyfill?
 */
function TouchPosition() {
	this.clear();
}
TouchPosition.prototype.set = function(x, y, isUpdateX, isUpdateY) {
	var movedTowardsEdge = {};
	
	// x
	var newX = roundNumber(x);
	if (newX > this._x) {
		movedTowardsEdge.x = 'left';
	} else if (newX < this._x) {
		movedTowardsEdge.x = 'right';
	}
	if (isUpdateX === undefined || isUpdateX === true) {
		this._x = newX;
	}
	
	// y
	var newY = roundNumber(y);
	if (newY > this._y) {
		movedTowardsEdge.y = 'top';
	} else if (newY < this._y) {
		movedTowardsEdge.y = 'bottom';
	}
	if (isUpdateY === undefined || isUpdateY === true) {
		this._y = newY;
	}
	
	return {
		x: this._x,
		y: this._y,
		movedTowardsEdge: movedTowardsEdge
	};
}
TouchPosition.prototype.setUsingEvent = function(event, isUpdateX, isUpdateY) {
	var isTouch = (event.targetTouches !== undefined);
	var targetTouch = isTouch? event.targetTouches[0] : event;
	var x = isTouch? targetTouch.clientX : targetTouch.clientX;
	var y = isTouch? targetTouch.clientY : targetTouch.clientY;
	return this.set(x, y, isUpdateX, isUpdateY);
}
TouchPosition.prototype.get = function() {
	return {
		x: this._x,
		y: this._y
	};
}
TouchPosition.prototype.clear = function() {
	this._x = null;
	this._y = null;
}

function roundNumber(val) {
	return Math.round(val * 100) / 100;
}

module.exports = TouchPosition;

